const template = `
	<div class="map-chart">
		<div class="chart-inner">
			<highcharts
				v-if="chart && loaded"
				constructorType="mapChart"
				:options="opts"
			></highcharts>
			<div v-else class="loading-label">{{ ii('LOADING') }}...</div>
		</div>
	</div>
`;

export default {
	template,
	props: ['title', 'chart', 'tooltip-unit'],
	data() {
		return {
			loaded: false
		};
	},
	computed: {
		opts() {
			let v = this;

			let opts = {
				chart: {
					map: 'custom/world-robinson-lowres',
					spacingTop: 35,
					marginTop: 85,
					style: {
						fontFamily: 'Roboto, "Open Sans", sanf-serif, helvetica, tahoma, verdana'
					}
				},
				title: {
					text: this.title,
					style: {
						textTransform: 'uppercase',
						fontWeight: 500,
						fontSize: 16
					}
				},
				legend: {
					title: {
						text: '',
						style: {
							color: 'black'
						}
					}
				},
				tooltip: {
					hideDelay: 100,
					headerFormat: '',
					pointFormatter() {
						let val = v.util.numFormat(this.value);
						let countryName = v.ii('GEO_' + this.geo);
						return `
							<span>
								<span style="color:${this.color}">●</span> ${countryName}
							</span>
							<br>
							<span>${v.tooltipUnit}: <b>${val}</b></span>
						`;
					}
				},
				mapNavigation: {
					enabled: true,
					buttonOptions: {
						alignTo: 'spacingBox'
					}
				},
				colorAxis: {
					min: 1,
					max: this.chart.max,
					type: 'logarithmic'
				},
				series: [{
					type: 'map',
					data: this.chart.data,
					joinBy: ['iso-a2', 'geo'],
					states: {
						hover: {
							color: '#4bbbee'
						}
					}
				}]
			};
			return opts;
		}
	},
	async mounted() {
		await this.loader.loadScript('/ecma/vendor/highmaps-world-robinson.min.js?format=iife');
		this.loaded = true;
	}
}